export default {
    transferSelectFromAccount: {
        dataTrackId: 'transfer-select-from-account',
        dataTrackLinkname: 'overforing velg fra konto',
    },
    transferSelectAccountModal: {
        dataTrackId: 'transfer-select-account-modal',
        dataTrackLinkname: 'overforing popup velg konto',
    },
    transferFetchAccountsFail: {
        dataTrackId: 'transfer-fetch-accounts-fail',
        dataTrackLinkname: 'overforing henting av konto feil',
    },
    transferCardAccountOptions: {
        dataTrackId: 'transfer-card-account-options',
        dataTrackLinkname: 'overforing velg konto',
    },
    transferPaymentAmount: {
        dataTrackId: 'transfer-payment-amount',
        dataTrackLinkname: 'overforing legg inn belop',
    },
    transferBankIdModal: {
        dataTrackId: 'transfer-bank-id-modal',
        dataTrackLinkname: 'overforing popup bankid-signering',
    },
    transferCancel: {
        dataTrackId: 'transfer-cancel',
        dataTrackLinkname: 'overforing avbryt',
    },
    transferErrorMessage: {
        dataTrackId: 'transfer-error-message',
        dataTrackLinkname: 'overforing feilmelding',
    },
    transferSubmit: {
        dataTrackId: 'transfer-submit',
        dataTrackLinkname: 'overforing bekreft',
    },
    transferButton: {
        dataTrackId: 'transfer-button-kredittbanken',
        dataTrackLinkname: 'transfer button kredittbanken',
    },
    paymentButton: {
        dataTrackId: 'payment-button-kredittbanken',
        dataTrackLinkname: 'payment button kredittbanken',
    },
};
